module.exports = __webpack_public_path__ + "static/media/img_36.74c98921.png";